<template>
  <div>
    <div class="CircleWave-wrap">
      <div class="wave wave5"></div>
      <!-- <div class="wave wave4"></div> -->
      <!-- <div class="wave wave3"></div> -->
      <div class="wave wave2"></div>
      <!-- <div class="wave wave1"></div> -->
      <div class="wave wave0"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircleWave',
  props: ['data', 'mainText', 'subText'],
  components: {},
  data () {
    return {
      // 音檔是否正在撥放
      mediaPlaying: false
    }
  },
  created () {},
  computed: {},
  methods: {}
}
</script>
<style scoped lang="scss">
.CircleWave-wrap {
  position: relative;
  height: 200px;
  width: 200px;
}
// 圓圈水波 css start
.wave {
  position: absolute;
  top: calc((100% - 140px) / 2);
  left: calc((100% - 140px) / 2);
  width: 140px;
  height: 140px;
  border-radius: 140px;
}
.wave0 {
  background: #f5d470;
  opacity: 0.3;
  z-index: 2;
  background-size: auto 106%;
  animation: w 2s forwards infinite;
}
.wave1 {
  background: #f5d470;
  opacity: 0.3;
  z-index: 3;
  animation: w 2s 0.4s forwards infinite;
}
.wave2 {
  background: #f5d470;
  opacity: 0.3;
  z-index: 4;
  animation: w 2s 0.8s forwards infinite;
}
.wave3 {
  background: #f5d470;
  opacity: 0.3;
  z-index: 5;
  animation: w 2s 1s forwards infinite;
}
.wave4 {
  background: #f5d470;
  opacity: 0.3;
  z-index: 6;
  animation: w 2s 1.6s forwards infinite;
}
.wave5 {
  background: #f5d470;
  opacity: 0.3;
  z-index: 7;
  animation: w 2s 2s forwards infinite;
}
@keyframes w {
  0% {
    top: calc((100% - 140px) / 2);
    left: calc((100% - 140px) / 2);
    width: 140px;
    height: 140px;
  }
  100% {
    top: calc((100% - 180px) / 2);
    left: calc((100% - 180px) / 2);
    width: 180px;
    height: 180px;
  }
}
// 圓圈水波 css end
</style>
<style lang="scss"></style>
